import React from 'react';
import classnames from 'classnames';
import DumbView from '../../../../DeviationViews/Thumb/Shop';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getSizeForFreeform } from '../../helpers';
import s from './Commission.scss';
var CommissionMonoReactView = function (_a) {
    var _b = _a.config, alignment = _b.alignment, link = _b.link, configuredWidth = _b.width, settings = _a.settings, deviation = _a.deviation;
    var size = {
        width: 330,
        height: 340,
    };
    // Handle resizing
    size = getSizeForFreeform(size, configuredWidth);
    if (settings && settings.showMediaAlwaysSmall) {
        size = {
            width: 212,
            height: 218,
        };
    }
    return (React.createElement("div", { className: classnames(s['root'], s['normal'], alignment && s[alignment]), style: { width: size.width } },
        React.createElement(EditorDeviationLink, { link: link, deviation: deviation, linkClass: "gallery-link" },
            React.createElement(DumbView, { width: size.width, height: size.height, deviation: deviation }))));
};
CommissionMonoReactView.displayName = 'CommissionMonoReactView';
export default CommissionMonoReactView;
//# sourceMappingURL=Commission.js.map